import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TeamManagementService } from 'src/app/_services/new-settings/team-management.service';
import { TransactionService } from 'src/app/_services/transaction.service';

@Component({
    selector: 'app-autopilot-permission',
    templateUrl: './autopilot-permission.component.html',
    styleUrls: ['./autopilot-permission.component.scss'],
    standalone: false
})
export class AutopilotPermissionComponent implements OnInit {
  alllist: any = [];
  tabList: any = [];
  adminDetails: any;
  showYourTeamTab: Boolean = true;
  showPendingTab: Boolean = false;
  showInvitationTab: Boolean = false;
  teamListCount: number = 0
  pendingListCount: number = 0;
  InvitationListCount: number = 0;
  isaiSourcingEnabled: boolean = false;
  planDetails: any = {};
 autopilotAccessControl: UntypedFormControl = new UntypedFormControl(false);
 successMessage: string = '';
 errorMessage: string = '';

  constructor(private teammanagementservice: TeamManagementService, private localstorageservice: LocalStorageService, private transactionService: TransactionService,
    private aiSourcingService: AiSourcingService
    ) { }

  ngOnInit() {
    this.fetchPlanDetails();
    this.fetchInviteTeamMembers();
  }

    /**
   * Get all the invite team members
   */
  fetchInviteTeamMembers() {

    const index = "0";

    this.teammanagementservice.fetchallteaminvites(index).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.alllist = res.teaminvitesarray;
        if (res.teamAdminDetails && res.teamAdminDetails?.firstname) {
          this.adminDetails = res.teamAdminDetails;
        } else {
          this.adminDetails = null;
        }
        // this.adminDetails['selected'] = false;
     //   if(onPageRefresh) {
          this.tabList = this.alllist?.filter((res: any) => res.invitestatus == 'accepted');
          this.teamListCount = this.alllist?.filter((res: any) => res.invitestatus == 'accepted').length;
          this.teamListCount = Number(this.teamListCount) + Number(this.adminDetails ? 1 : 0);
          this.pendingListCount = this.alllist?.filter((res: any) => res.invitestatus == 'sent').length;


      } else {
        this.alllist = [];
        this.adminDetails = null;
      }

    })

  };

    /**
   * Get current plan details
   */
  fetchPlanDetails() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const creditsData = this.transactionService.credits();
    if (creditsData) {
      this.planDetails = creditsData;
      this.isaiSourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess');
    } else {
      this.planDetails = {};
    }
  };

  toggleAutopilotAcces(team: any) {

    const payload = {
      data: [{
        loginemail: team?.inviteeemailid,
        autopilotaccess: !team?.hasaisourcingaccess
      }]
    }
    this.aiSourcingService.getAutopilotaccess(payload).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Autopilot Access Updated Successfully!';
        setTimeout(() => this.successMessage = '', 5000);
        this.fetchInviteTeamMembers();
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

}
